import { render, staticRenderFns } from "./AddNewRole.vue?vue&type=template&id=264c324a&"
import script from "./AddNewRole.vue?vue&type=script&lang=js&"
export * from "./AddNewRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports